module.exports = __webpack_public_path__ + "static/rf-screenshot-profile-2-c09c1829a88ab4575c97e811d8a737fb.jpg";